exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".page-section{padding:50px 0;background-color:#fff}.page-section--thin{padding:25px 0}.page-section--contrast{background-color:#f5f5f5}.page-section--primary{background-color:#5f8f93;color:#fff}.page-section--primary-light{background-color:#87ccd3;color:#fff}.page-section__title{margin-bottom:25px;font-size:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./src/page-layout.styl
// module id = 524
// module chunks = 0